/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { type ReactElement } from 'react';
import { flagService } from '../../services/index.tsx';
import type { FlagService } from '../../services/types.tsx';

export type FlagServiceSubscriberProps = {
	children: (flagService: FlagService) => ReactElement;
};

const FlagServiceSubscriber = (props: FlagServiceSubscriberProps): React.JSX.Element => (
	<>{props.children(flagService)}</>
);

export default FlagServiceSubscriber;
